<template>
    <div>
        <form class="large-form">
            <div class="form-line">
                <div class="form-field" id="form-field-name" style="width: 100%;" v-if="type==='activated-template'">
                    <div class="small-note">
                        <span>Survey Template</span> has been activated - it has been copied from templates into your surveys.
                        You can adjust the survey name and type below if you wish - and then customise survey questions or start using it right away!
                    </div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" id="form-field-name" style="width: 100%;">
                    <label for="form-input-name">Survey Name</label>
                    <input id="form-input-name" type="text" v-model="model.name" required>
                    <div class="field-note">Survey name will be visible to your respondents.</div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" id="form-field-select">
                    <label for="form-input-type">Survey Type</label>
                    <WSSelect :options="surveyTypes" v-model="model.category" />
                    <div class="field-note">Please choose the most suitable survey category.</div>
                </div>
            </div>

            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>

            <div v-if="survey.id" style="text-align: right">
                <div class="ws-button ws-button-negative small" @click="onDelete">Delete Survey</div>
            </div>
            
        </form>
        <div class="form-actions">
            <div type="button" class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div type="submit" class="ws-button ws-button-main" @click="onSubmit" v-html="survey.name?'Save Changes':'Create New Survey'"></div>
        </div>
    </div>
</template>

<script>
import { snakeCase } from "lodash-es";
import MediaGallerySelector from "@/components/MediaGallerySelector";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'SurveySettingsForm',
    components: {WSSelect},
    props: {
        type: {
            type: String,
            default: 'standard'
        },
        survey: {
            type: Object,
            default: () => ({
                name: undefined,
                category: 'research',
            })
        }
    },
    data() {
        return {
            model: {
                name: undefined,
                category: undefined,
            },
            errors: null,
        }
    },
    created() {
        this.resetModel();
    },
    methods: {
        onSubmit() {
            let fieldsToValidate = [{ name: 'Survey name', value: this.model.name, rules: ['required'] }];
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return;
            
            this.model.createWelcomePage = true;
            this.$emit('save', {...this.model})
        },
        resetModel() {
            this.model = {...this.survey}
        },
        onCancel() {
            this.$emit('cancel')
        },
        onDelete() {
            if (confirm('Are you sure you want to delete this survey?')) {
                this.$store.dispatch('surveys/delete', this.survey);
                this.$router.push({path: '/surveys'});
            }
        }
        
    },
    computed: {
        surveyTypes() {
            return this.$store.state.surveyTypes;
        }
    }
}
</script>
